import { createRoot } from 'react-dom/client';
import './index.css';
import { initRainguard } from '@Services/rainguard/rainguard.service';
import { InitApp } from './InitApp.tsx';

initRainguard();

createRoot(document.getElementById('root')!).render(
  <>
    <InitApp />
  </>
);
